import { CircleInfo } from 'bvt-icon';
import React from 'react';
import PropTypes from 'prop-types';
import { AnalyzeCard } from '@bvt-molecules';
import PeopleDensityDashboard from './components/PeopleDensityDashboard';
import PeopleDensitySidebar from './components/PeopleDensitySidebar';

/**
 * People Density
 * @param {object} props
 * @param {string} props.value
 * @param {'sidebar' | 'dashboard'} props.type
 * @param {object} props.detail
 * @param {string | number} props.detail.year
 * @param {string} props.detail.month
 * @param {string | number} props.detail.date
 * @param {string} props.detail.timeType
 * @param {string} props.detail.time
 */

function PeopleDensity(props) {
  const { value, type, detail } = props;
  return (
    <AnalyzeCard
      headerIcon={<CircleInfo height='1.25rem' width='1.25rem' />}
      headerText='People density'
    >
      {type === 'sidebar' ? (
        <PeopleDensitySidebar value={value} />
      ) : (
        <PeopleDensityDashboard detail={detail} value={value} />
      )}
    </AnalyzeCard>
  );
}

export default PeopleDensity;

PeopleDensity.defaultProps = {
  detail: {
    year: '2022',
    month: 'January',
    date: '1',
    timeType: 'Specific time',
    time: '09:00 AM',
  },
  type: 'sidebar',
  value: '25.447',
};

PeopleDensity.propTypes = {
  detail: PropTypes.shape({
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    month: PropTypes.string,
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    timeType: PropTypes.string,
    time: PropTypes.string,
  }),
  type: PropTypes.oneOf(['sidebar', 'dashboard']),
  value: PropTypes.string,
};
